<template lang="pug">
  div
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'servicegroupBarChartByHttpStatus'"
                :useBackendDatasetLabel="true"
                :topNSize="5"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="colorScheme.colorSets.border"
                :barBackgroundColors="colorScheme.colorSets.fill"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'domainBarChartByHttpStatus'"
                :useBackendDatasetLabel="true"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="colorScheme.colorSets.border"
                :barBackgroundColors="colorScheme.colorSets.fill"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'uriBarChartByHttpStatus'"
                :useBackendDatasetLabel="true"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="colorScheme.colorSets.border"
                :barBackgroundColors="colorScheme.colorSets.fill"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";
export default {
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper
    },
    props: {
        groupNames: {
            type: Array,
            default: () => []
        },
        serviceGroupNames: {
            type: Array,
            default: () => []
        },
        domains: {
            type: Array,
            default: () => []
        },
        origins: {
            type: Array,
            default: () => []
        },
        edgeNames: {
            type: Array,
            default: () => []
        },
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        direction: {
            type: String,
            default: "vertical"
        }
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280
        };
    }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HomePage/MonitoringContent.vue